import { Component, Input } from '@angular/core';
import { CommonService } from '../../Model/Common/common.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-view-image-doc',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './view-image-doc.component.html',
  styleUrl: './view-image-doc.component.scss'
})
export class ViewImageDocComponent {
  @Input() ImageDocPath: string = '';
  constructor(
    protected common: CommonService,
    protected sanitizer: DomSanitizer,
    private activeModal: NgbActiveModal,
  ) { }

  ngOnInit(): void { }
  
  close() {
    this.activeModal.close();
  }
}
